'use strict';

import computoProyectoComponent from './computo-proyecto.component';
import resumenComputosComponent from './resumen/resumen.component';
import fotosComputosComponent from './fotos/fotos.component';
import computosMetricosComponent from './computos-metricos/computos-metricos.component';
import importacionComputosComponent from '../../integracion-siga/importacion-computos/importacion-computos.component'
import ComputoService from './computo.service';
import IntegracionService from '../../integracion-siga/integracion.service';

const computoProyecto = angular
    .module('app.computoProyecto', [])
    .component('computoProyecto', computoProyectoComponent)
    .component('resumenComputos', resumenComputosComponent)
    .component('fotosComputos', fotosComputosComponent)
    .component('computosMetricos', computosMetricosComponent)
    .component('importacionComputos', importacionComputosComponent)
    .service('Computo', ComputoService)
    .service('Integracion', IntegracionService)
    .name;

export default computoProyecto;



// WEBPACK FOOTER //
// ./src/app/components/empresas/computo-proyecto/computo-proyecto.module.js